import { ref } from 'vue';
import axios from 'axios';

const name = ref('');
const phone = ref('');
const email = ref('');
const countryCode = ref('+55');
const isSending = ref(false);
const isProcessing = ref(false);
let lastSubmissionTime = 0;

export function useWhatsAppChat() {
  const formatPhone = (input) => {
    phone.value = input.target.value.replace(/\D/g, "");
    phone.value = phone.value.replace(/^\+55|^55/, "");

    if (phone.value.length === 11) {
      phone.value = phone.value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    } else if (phone.value.length === 10) {
      phone.value = phone.value.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }
  };

  const generateWhatsAppLink = (phoneNumber, message) => {
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    try {
      message = message.replaceAll("%", "%25");
      message = encodeURIComponent(decodeURI(message));
    } catch (e) {
      message = encodeURIComponent(message);
    }

    let link = isMobile
      ? `https://wa.me/${phoneNumber}?text=${message}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

    window.open(link, "_blank", "noopener");
    conversion();
  };

  const conversion = () => {
    if (process.env.VUE_APP_ENV === "production") {
      window.gtag("event", "conversion", {
        send_to: "AW-11020125432/hwoPCKLHyooYEPiJ54Yp",
      });
    }
  };

  const sendMessage = async () => {
    if (!name.value.trim() || !phone.value.trim()) {
      alert("Por favor, preencha os campos obrigatórios: Nome e Telefone.");
      return;
    }

    // Previne submissões muito rápidas (menor que 500ms)
    const now = Date.now();
    if (now - lastSubmissionTime < 500) {
      return;
    }
    lastSubmissionTime = now;

    // Inicia o processo de envio
    isSending.value = true;

    try {
      await axios.post("public/schedule", {
        name: name.value,
        email: email.value,
        phone: countryCode.value + phone.value,
        tag: "whatsapp",
      });

      generateWhatsAppLink(
        '5515998341602',
        `Olá, meu nome é ${name.value}. Estou interessado em saber mais sobre os serviços da BCompliance&Law.`
      );
    } catch (error) {
      console.error("Erro ao enviar mensagem:", error);
      alert("Ocorreu um erro ao enviar a mensagem. Por favor, tente novamente.");
    } finally {
      isSending.value = false;
      isProcessing.value = false;
    }
  };

  return {
    name,
    phone,
    email,
    countryCode,
    isSending,
    isProcessing,
    formatPhone,
    sendMessage,
  };
}